import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/api';
import { Subscription } from 'rxjs';
import { AuthTokenService } from 'src/app/services/auth.token.service';

@Component({
  selector: 'app-exit',
  templateUrl: './exit.component.html',
})
export class ExitComponent {

  messages: Message[];

  exitSubscription: Subscription

  constructor(
    private router: Router,
    private authTokenService: AuthTokenService
  ) { }

  ngOnDestroy() {
    if (this.exitSubscription) this.exitSubscription.unsubscribe();
  }

  onExitClick() {
    this.authTokenService.removeAuth()
    this.router.navigate(['/base/login'])
  }
}
